import { render, staticRenderFns } from "./SimNumeroFormGeneral.vue?vue&type=template&id=6c5685f6&"
import script from "./SimNumeroFormGeneral.vue?vue&type=script&lang=ts&"
export * from "./SimNumeroFormGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports